import React from 'react';
import styles from '../accommodation-gallery.module.scss';

type Props = {
  index: number;
  numberOfImages: number;
  text: string;
  showText?: boolean;
};

export const ImageCaption = ({ index, numberOfImages, text, showText = true }: Props) => (
  <div>
    <span className={styles.imageNumber}>{`${index + 1} of ${numberOfImages}`}</span>
    {showText && <span>{text}</span>}
  </div>
);
